class Timer {
    end = null;
    timerElement = null;
    interval = null;
    defaultParams = {
        textColor: '#FFFFFF',
        backgroundColor: '#2C2C2C',
    };

    constructor(elementId, params = {}) {
        this.container = document.getElementById(elementId);

        if (!this.container) {
            return console.error(`Cannot find element "#${elementId}"`);
        }

        params = {...this.defaultParams, ...params};

        if (!params.end) {
            return console.error(`End dates must be specified for timer #${elementId} to work`);
        }

        this.end = new Date(params.end);
        this.textColor = params.textColor;
        this.backgroundColor = params.backgroundColor;

        const time = this.getRemainingTime();

        if (this.isTimeRemaining(time)) {
            this.createElement(time);
            this.start();
        } else {
            console.info(`No time remaining for timer #${elementId}`);
        }
    }

    isTimeRemaining(time) {
        return Object.values(time).reduce((a, b) => b > 0, false);
    }

    getHtmlTimeDuration(time) {
        return `P${time.days}DT${time.hours}H${time.minutes}M${time.seconds}S`;
    }

    getRemainingTime() {
        const remainingTime = this.end.getTime() - new Date().getTime();

        return {
            days: Math.floor(remainingTime / (1000 * 60 * 60 * 24)),
            hours: Math.floor(remainingTime / (1000 * 60 * 60) % 24),
            minutes: Math.floor(remainingTime / 1000 / 60 % 60),
            seconds: Math.floor(remainingTime / 1000 % 60),
        }
    }

    createElement(time) {
        this.container.innerHTML = `
            <timer class="timer" 
                   role="timer" 
                   datetime="${this.getHtmlTimeDuration(time)}"
                   style="background-color: ${this.backgroundColor}; color: ${this.textColor}"
            >
                <span class="timer__digits">${time.days}</span>
                <span class="timer__digits">${time.hours}</span>
                <span class="timer__digits">${time.minutes}</span>
                <span class="timer__digits">${time.seconds}</span>
                <span class="timer__letters">${BX.message('TIMER_DAYS')}</span>
                <span class="timer__letters">${BX.message('TIMER_HOURS')}</span>
                <span class="timer__letters">${BX.message('TIMER_MINUTES')}</span>
                <span class="timer__letters">${BX.message('TIMER_SECONDS')}</span>
            </timer>
        `;
        this.timerElement = this.container.firstElementChild;
    }

    updateElement(time) {
        const [days, hours, minutes, seconds] = this.timerElement.children;

        this.timerElement.setAttribute('datetime', this.getHtmlTimeDuration(time));
        days.textContent = time.days;
        hours.textContent = time.hours;
        minutes.textContent = time.minutes;
        seconds.textContent = time.seconds;
    }

    start() {
        this.interval = setInterval(() => this.tick(), 1000);
    }

    tick() {
        const time = this.getRemainingTime();

        this.updateElement(time);

        if (!time) {
            this.stop();
        }
    }

    stop() {
        clearInterval(this.interval);
    }
}
